import { makeAutoObservable } from "mobx";
import { createMutations } from "./mutations";
import { initialState, templateInitialState, formBuilderState } from "./state";

/**
 * @typedef {typeof initialState & {
 *   setCurrentPage: (value: any) => void,
 *   setPageSize: (value: any) => void,
 *   setFilterSearchText: (value: any) => void,
 *   setFilterModel: (value: any) => void,
 *   setIsLoading: (value: any) => void,
 *   setRowData: (value: any) => void,
 *   setShowFilterModal: (value: any) => void,
 *   setForms: (items: any[]) => void,
 *   setForm: (item: any) => void,
 *   setTotalRow: (value: any) => void,
 *   setDefaultState: () => void,
 *   setTemplateDefaultState: () => void,
 *   setTemplateCurrentPage: (value: any) => void,
 *   setTemplatePageSize: (value: any) => void,
 *   setTemplateFilterSearchText: (value: any) => void,
 *   setTemplateFilterModel: (value: any) => void,
 *   setTemplateForms: (items: any[]) => void,
 *   setTemplateTotalRow: (value: any) => void,
 *   setTemplateIsLoading: (value: any) => void,
 *   setTemplateShowFilterModal: (value: any) => void,
 *   setTemplateActiveFormTab: (value: any) => void,
 *   setTemplateFormDescription: (value: any) => void,
 *   setTemplateFormCategories: (value: any) => void
 *   setSuggestions: (value: any) => void
 * 
 * }} FormStore
 */

const formStore = () => {
  const store = {
    ...initialState,
    ...templateInitialState,
    ...formBuilderState
  };
  makeAutoObservable(store);

  Object.assign(store, createMutations(store));


  /** @type {FormStore} */
  return store;
};

/** @type {FormStore} */
export default formStore();